import { DataTable, Dialog, Heading, Loader } from "@/components";
import { Button, Input } from "@/components/ui";
import { Search } from "lucide-react";
import useEmployee from "./useEmployee";
import { rolesOptions } from "@/lib/utils";

const Employee = () => {
  const {
    onAddEmployee,
    globalFilter,
    setGlobalFilter,
    columns,
    employeeList,
    isEmployeeLoading,
    isMobile,
    setPageNumber,
    setPageSize,
    pageNumber,
    pageSize,
    sorting,
    setSorting,
    isEmployeeRefetching,
    showAffiliationDialog,
    setShowAffiliationDialog,
    userPermission,
    isUserPermissionLoading,
  } = useEmployee();

  return (
    <div className="p-4 md:p-6">
      {/* Header & Search */}
      <div className="flex flex-col lg:flex-row gap-2 lg:items-center lg:justify-between mb-6">
        <div className="flex flex-row items-center justify-between">
          <Heading title="CAM / CAM-A" />
          {isMobile && (
            <Button onClick={onAddEmployee} className="px-2">
              + Add
            </Button>
          )}
        </div>
        <div className="flex flex-row items-center gap-4">
          {/* <Button className="bg-white text-g-500 border-g-200 border-1 hover:bg-white">
            <ListFilterIcon />
          </Button> */}
          <Input
            type="text"
            placeholder="Search"
            value={globalFilter ?? ""}
            onChange={(e) => {
              setPageNumber(0);
              setGlobalFilter(e.target.value);
            }}
            className="w-full sm:w-72 bg-white h-[40px]"
            startIcon={<Search className="w-4 h-4" />}
          />
          {!isMobile && <Button onClick={onAddEmployee}>+ Add</Button>}
        </div>
      </div>

      {/* Responsive Table */}
      {isEmployeeLoading || isEmployeeRefetching ? (
        <Loader />
      ) : (
        <>
          <DataTable
            columns={columns}
            data={[...(employeeList?.data || [])]}
            setPageNumber={setPageNumber}
            setPageSize={setPageSize}
            pageNumber={pageNumber}
            pageSize={pageSize}
            totalPages={Math.ceil(employeeList?.total / pageSize)}
            totalRecords={employeeList?.total}
            serverSidePagination={true}
            sorting={sorting}
            onSortingChange={setSorting}
          />
        </>
      )}

      {showAffiliationDialog && (
        <Dialog
          open={showAffiliationDialog}
          setOpen={setShowAffiliationDialog}
          title={
            <div className="text-2xl font-bold text-primary">
              {"Community Affiliation"}
            </div>
          }
          hideFooter
        >
          <div className="relative">
            {isUserPermissionLoading ? (
              <Loader />
            ) : (
              <div>
                <div className="grid grid-cols-2 gap-10 text-primary font-[600] mb-3">
                  <span>Community Name</span>
                  <span>Role</span>
                </div>
                {userPermission?.data?.map((data: any) => {
                  const uniqueRoles = [
                    ...new Set(
                      data?.permissions.map((data: any) => data.userRole)
                    ),
                  ];

                  return (
                    <div className="grid grid-cols-2 gap-10 mb-3">
                      <span>{data.communityName}</span>
                      <span>
                        {
                          rolesOptions.find(
                            (data: any) => data.value == uniqueRoles?.toString()
                          )?.label
                        }
                      </span>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </Dialog>
      )}
    </div>
  );
};

export default Employee;
